import React from 'react';
import { Divider, Stack, Typography, Box } from '@mui/material';
import Iconify from '@/components/Iconify';
import { fCurrency } from '@/utils/formatNumber';
import { useModals } from '@mattjennings/react-modal-stack';
import RemoveTicketInsuranceDialog from '../addons/RemoveTicketInsuranceDialog';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';
import { useAddOns, useSummary } from '@/store';
import useAddOnsControl from '../addons/useAddOnsControl';

export default function TicketInsuranceDetail({
  currency,
  disabledTicketInsuranceAction = false,
  ticketInsurance,
}) {
  const {
    ticketInsurance: { selected, touched },
  } = useAddOns();

  const { ticketInsurancePrice, toggleTicketInsurance } = useAddOnsControl();

  const { insuranceRemovedFromSummary, insuranceReactivatedInSummary } =
    useAnalyticsEvents();
  const { openModal } = useModals();

  useSummary();

  const onRemove = async () => {
    const resp = await removeDialog();
    if (resp) {
      toggleTicketInsurance(false);
      insuranceRemovedFromSummary();
    }
  };
  const onAdd = () => {
    toggleTicketInsurance(true);
    insuranceReactivatedInSummary();
  };

  const removeDialog = () => {
    return new Promise((resolve) => {
      openModal(RemoveTicketInsuranceDialog, {
        onConfirm: async () => {
          resolve(true);
        },
        onClose: async () => {
          resolve(false);
        },
      });
    });
  };

  return (
    <>
      {touched && (
        <>
          <Stack
            sx={{ mt: 2, mb: 2 }}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Divider sx={{ width: '100%' }} />
          </Stack>

          {selected ? (
            <>
              <Stack
                sx={{
                  width: '100%',
                  marginBottom: '4px',
                }}
              >
                <Stack direction="row" justifyContent="space-between">
                  <Typography component={'div'} sx={{ fontSize: '14px' }}>
                    Protección de tu compra
                  </Typography>

                  <Typography sx={{ fontSize: '14px' }}>
                    {`${fCurrency(ticketInsurance || ticketInsurancePrice)} ${
                      currency ? currency : ''
                    }`}
                  </Typography>
                </Stack>
                <Box sx={{ minWidth: 80 }}>
                  {!disabledTicketInsuranceAction && (
                    <Typography
                      variant="caption2"
                      onClick={onRemove}
                      component={'div'}
                      sx={{
                        textDecoration: 'underline',
                        cursor: 'pointer',
                      }}
                    >
                      Quitar{' '}
                      <Iconify
                        width={12}
                        height={12}
                        icon={'simple-line-icons:close'}
                      />
                    </Typography>
                  )}
                </Box>
              </Stack>
            </>
          ) : (
            <>
              <Stack
                direction="row"
                sx={{
                  width: '100%',
                  alignItems: 'center',
                  marginBottom: '4px',
                }}
              >
                <Box sx={{ minWidth: 80 }}>
                  {!disabledTicketInsuranceAction && (
                    <Typography
                      variant="body3"
                      component={'div'}
                      onClick={onAdd}
                      sx={{
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        color: '#0F8656',
                      }}
                    >
                      Reactivar mi protección
                    </Typography>
                  )}
                  {disabledTicketInsuranceAction && (
                    <Typography variant="body3" component={'div'}>
                      Protección de tu compra
                    </Typography>
                  )}
                </Box>
                <Box sx={{ flexGrow: 1 }}></Box>
                <Box>
                  <Typography
                    variant="body2"
                    sx={{
                      lineHeight: '36px',
                      textDecoration: 'line-through',
                    }}
                  >
                    {`${fCurrency(ticketInsurancePrice)} ${
                      currency ? currency : ''
                    }`}
                  </Typography>
                </Box>
              </Stack>
            </>
          )}
        </>
      )}
    </>
  );
}
